export default "__VITE_ASSET__BCrgx0G2__"